import React from 'react';
import { TabsContent } from "@/components/ui/tabs";
import BikeStatusChart from "../BikeStatusChart";
import BikeLocationChart from "../BikeLocationChart";

interface BikesTabProps {
  isLoading: boolean;
  bikes: any[];
}

const BikesTab: React.FC<BikesTabProps> = ({ isLoading, bikes }) => {
  // Process the bikes data to ensure user locations are properly formatted
  const processedBikes = bikes.map(bike => {
    if (bike.users?.username) {
      return {
        ...bike,
        location: `Home: ${bike.users.username}`
      };
    }
    return bike;
  });
  
  return (
    <TabsContent value="ebikes" className="space-y-6">
      <div className="grid gap-6 md:grid-cols-2">
        <BikeStatusChart
          isLoading={isLoading}
          bikes={processedBikes}
        />
        <BikeLocationChart
          isLoading={isLoading}
          bikes={processedBikes}
        />
      </div>
    </TabsContent>
  );
};

export default BikesTab;
